import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useLabelFormatStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            display: "flex",
            alignItems: "center",
        },
        icon: {
            marginRight: theme.spacing(0.5),
            height: "14px",
        },
    })
);
